import React, { PureComponent } from "react";
import TreeDataTable from "cp-react-tree-table";
import _ from "i18n";

import { getTimeByDurationFormat } from "Utils";
import Variance from "../Variance/Variance";
import { EntityIcon, PelletGoIcon } from "../Icons";
import { Tooltip } from "antd";
import styles from "./Tables.local.scss";
import StickyTableHeader from "../StickyTableHeader/StickyTableHeader";
import { TiWarningOutline } from "react-icons/ti";
import classnames from "classnames";

class TreeTable extends PureComponent {
  treeTableRef = React.createRef();

  constructor(props) {
    super(props);
    this.treeTableRef = React.createRef();
  }

  render() {
    const header = {
      label: "",
      type: "header"
    };
    this.props.periods.forEach(
      p =>
        (header[p] = {
          value: p,
          isHeader: true
        })
    );
    const data = [{ data: header }, ...this.props.dataSource];
    const { expandAll } = this.props;
    return (
      <div style={{ overflow: "scroll", position: "relative" }}>
        <StickyTableHeader columns={this.props.columns} benchmark={null} />
        <TreeDataTable
          ref={elem => {
            if (elem) {
              this.treeTableRef = elem;
            }
            if (expandAll) {
              this.treeTableRef.expandAll(4);
            }
          }}
          height="800"
          headerHeight="47"
          onChange={this.handleOnChange}
          data={data}
        >
          <TreeDataTable.Column
            renderCell={this.renderIndexCell}
            renderHeaderCell={this.renderHeaderCell("Name")}
            basis="350px"
            grow="1"
          />

          {this.props.periods.map(period => (
            <TreeDataTable.Column
              renderCell={this.renderPeriodCell(period)}
              renderHeaderCell={this.renderHeaderCell(period)}
              basis="150px"
              grow="1"
            />
          ))}
        </TreeDataTable>
      </div>
    );
  }

  handleOnChange = newValue => {
    this.setState({ treeValue: newValue });
  };

  renderHeaderCell = (name, alignLeft = true) => {
    return () => {
      return "";
    };
  };

  getOneCLientNameAttached = row => {
    let clientNameArr = [];
    row.attachedClients.map(
      item =>
        item.clientName
          .toLowerCase()
          .indexOf(this.props.filter.searchWord.searchWord.toLowerCase()) !== -1
          ? clientNameArr.push(item.clientName)
          : ""
    );
    return clientNameArr.slice(0, 1);
  };

  renderIndexCell = (row, metadata, toggleChildren) => {
    const { erpData } = this.props;
    // console.log("metadata==", metadata);
    let erpId = null;
    let erpLabel = null;
    if (erpData) {
      if (
        row.type === "COLLABORATOR" ||
        row.type === "RESPONSIBLE" ||
        row.type === "DELEGATED"
      ) {
        let colId = row.id.includes("_")
          ? row.id.substring(row.id.indexOf("_") + 1)
          : row.id;

        let data =
          erpData.collaborators !== undefined &&
          erpData.collaborators.filter(item => Object.keys(item)[0] === colId);

        erpId = erpData.collaborators !== undefined && data[0][colId]["erpId"];
        erpLabel =
          erpData.collaborators !== undefined && data[0][colId]["erpLabel"];
      } else if (row.type === "CLIENT") {
        let cliId = row.id.includes("_")
          ? row.id.substring(row.id.indexOf("_") + 1)
          : row.id;
        let data =
          erpData.clients !== undefined &&
          erpData.clients.filter(item => Object.keys(item)[0] === cliId);
        erpLabel = erpData.clients !== undefined && data[0][cliId]["erpLabel"];
        erpId = erpData.clients !== undefined && data[0][cliId]["erpId"];
      }
    }
    let nameLength = 0;
    if (row.type === "COLLABORATOR" && row.client)
      row.client.forEach(item => {
        nameLength += item.clientName.length;
      });
    return (
      <div
        style={{
          paddingLeft: metadata.depth * 15 + "px",
          backgroundColor: row.label === "total" ? "#c8cdd2" : ""
        }}
        className={`cell ${row.level} ${
          row.type === "TASK"
            ? "white"
            : row.type === "OBSERVATION"
              ? "yellow"
              : ""
        }
        ${row.id === "TOTAL" ? "blue_ciel" : ""} 
        ${metadata.hasChildren ? "with-children" : "without-children"}`}
      >
        {metadata.hasChildren ? (
          <span
            className={`toggle-button ${
              metadata.hasVisibleChildren ? "collapsed" : "expanded"
            }`}
            onClick={toggleChildren}
          />
        ) : (
          <span className={`toggle-button`} />
        )}
        <span
          className={row.label && row.label.length >= 40 ? "label-wrap" : ""}
        >
          {(row.label === "" && row.type === "TASK_TYPE") ||
          row.label === "nonAffectedDelegate"
            ? _("NoAffected")
            : row.label}
        </span>
        <div className={styles.label_style}>
          {row.category && this.props.types.includes(row.type)
            ? "( " + _(row.type) + " " + _(row.category) + " ) "
            : ""}
        </div>
        {erpData &&
        (row.type === "COLLABORATOR" ||
          row.type === "RESPONSIBLE" ||
          row.type === "DELEGATED" ||
          row.type === "CLIENT") ? (
          <Tooltip
            placement="right"
            title={
              <div style={{ textAlign: "left", width: "200%" }}>
                <div>
                  {_("importedFrom")} : {erpLabel}
                </div>
                <div>
                  {_("identifier")} : {erpId}
                </div>
              </div>
            }
          >
            <img
              data-for="info__undefined"
              data-tip=""
              className={styles.info_icon}
              src="/img/icons/info.svg"
              alt=""
              currentitem="false"
            />{" "}
          </Tooltip>
        ) : (
          ""
        )}
        {row.type === "CLIENT" &&
        row.attachedClients &&
        row.attachedClients.length &&
        this.props.filter.searchWord.searchWord.length ? (
          <div>
            {this.getOneCLientNameAttached(row).map(item => (
              <span
                className={
                  row.attachedClients &&
                  row.attachedClients[0]["clientName"].length > 40 &&
                  row.attachedClients[0]["clientName"].length < 65
                    ? classnames(styles.label_wrap, styles.attached_client)
                    : row.attachedClients &&
                      row.attachedClients[0]["clientName"].length > 65
                      ? classnames(
                          styles.label_wrap_medium_size,
                          styles.attached_client
                        )
                      : styles.attached_client
                }
              >
                {item}
              </span>
            ))}
          </div>
        ) : (
          ""
        )}
        <div
          className={classnames(
            nameLength >= 90
              ? "label-wrap-level-1"
              : nameLength >= 75
                ? "label-wrap-level-2"
                : nameLength >= 55
                  ? "label-wrap-level-3"
                  : nameLength >= 45
                    ? "label-wrap"
                    : "",
            styles.label_style
          )}
        >
          {row.type === "COLLABORATOR" && row.client
            ? row.client.map(item => " - " + item.clientName + "  ")
            : ""}
        </div>
        {this.props.types.includes(row.type) ? (
          <div className={"open-button"}>
            <span
              onClick={() =>
                this.props.handleReOpenTree(row.type, row.id, row.label)
              }
            >
              {<PelletGoIcon />}
            </span>
          </div>
        ) : (
          ""
        )}
        {row.type === "CLIENT" &&
          (row.nonAffected || row.attachedClients) && (
            <div className={"open-button"}>
              {row.type === "CLIENT" &&
              row.nonAffected &&
              row.nonAffected.value ? (
                <Tooltip
                  placement="right"
                  title={
                    <div style={{ textAlign: "left" }}>
                      <div>
                        {_("remainingBudget")}
                        {" : "}
                        {parseFloat(row.nonAffected.value)}
                      </div>
                    </div>
                  }
                >
                  <span>
                    <TiWarningOutline
                      style={{ width: "1.5em", height: "1.5em", color: "red" }}
                    />
                  </span>
                </Tooltip>
              ) : (
                ""
              )}
              {row.type === "CLIENT" &&
              row.attachedClients &&
              row.attachedClients.length ? (
                <Tooltip
                  placement="right"
                  title={
                    <div style={{ textAlign: "left" }}>
                      {" "}
                      <p>
                        {_("attachedClients")}
                        {" : "}
                      </p>
                      {row.attachedClients.map(item => (
                        <p>{"- " + item.clientName}</p>
                      ))}
                    </div>
                  }
                >
                  <div style={{ height: "18px" }}>
                    <EntityIcon
                      className={styles.info_icon}
                      color={"#6d7f92"}
                    />
                  </div>
                </Tooltip>
              ) : (
                ""
              )}
            </div>
          )}
      </div>
    );
  };

  renderTreeTdComponent = (row, fields) => {
    return (
      <span
        className={"balance-sheet-td-component "}
        style={{
          backgroundColor: row.label === "total" ? "#c8cdd2" : ""
        }}
      >
        <span className={"balance-sheet-td-value"}>
          {getTimeByDurationFormat(fields.value)}
        </span>
        {["CLIENT_GROUP", "CLIENT", "TOTAL"].includes(row.type) &&
          typeof fields.diff !== "undefined" && (
            <span className={"balance-sheet-td-percentage"}>
              <Variance variance={fields.diff} />
            </span>
          )}
      </span>
    );
  };

  renderPeriodCell = field => {
    return row => {
      return (
        <div
          className={`cell ${
            row.type === "TASK"
              ? "white"
              : row.type === "OBSERVATION"
                ? "yellow"
                : ""
          }
          ${row.id === "TOTAL" ? "blue_ciel" : ""}`}
        >
          {!row[field].isHeader
            ? this.renderTreeTdComponent(row, row[field])
            : row[field].value}
        </div>
      );
    };
  };
}

export default TreeTable;



// WEBPACK FOOTER //
// ./src/components/Common/Tables/TreeTable.js